"use strict";

define('service/dom',['appkit/service', 'jquery'], function (Service, $) {
  var DomService = Service.extend({
    replies: {
      'DOMWidth': 'calculateElementWidth',
      'imageDimensions': 'calculateImageDimensions',
      'imageAbsolutePath': 'convertImagePathsToAbsolute'
    },
    calculateElementWidth: function calculateElementWidth(el) {
      var div = $('<div/>'),
        clone = $(el).clone(),
        width = null;
      div.css({
        visibility: 'hidden',
        position: 'absolute',
        top: 0,
        left: 0
      });
      div.append(clone);
      $(document.body).append(div);
      width = div.width();
      div.remove();
      return width;
    },
    convertImagePathsToAbsolute: function convertImagePathsToAbsolute(input) {
      var div = $('<div/>').html(input);
      div.find('img').each(function (index, img) {
        var $img = $(img);
        $img.attr('src', $img.prop('src'));
      });
      return div.html();
    },
    calculateImageDimensions: function calculateImageDimensions(el) {
      var div = $('<div/>'),
        clone = $(el).clone(),
        width = null;
      div.css({
        visibility: 'hidden',
        position: 'absolute',
        top: 0,
        left: 0
      });
      return new Promise(function (resolve, reject) {
        div.append(clone);
        $(document.body).append(div);
        if (!clone.get(0).src) {
          resolve({});
          div.remove();
        } else {
          clone.load(function () {
            resolve({
              width: clone.get(0).width,
              height: clone.get(0).height
            });
            div.remove();
          }).on('error', function () {
            resolve({
              width: 0,
              height: 0
            });
            div.remove();
          });
        }
      });
    }
  });
  return DomService;
});

